import { CartModel } from "../Model/CartModel";

export function  AddUpdateCart(actionType : any, _Item_Id : any, _Item_Title : any, _Quantity : any, _Seller_Price : any, _Seller_Id : any, index : any=0, _Item_Title_Url : any){

    let model  =  {
    Item_Id : _Item_Id,
    Item_Title : _Item_Title,
    Quantity : _Quantity,
    Seller_Price : _Seller_Price,
    Seller_Id : _Seller_Id,
    Item_Title_Url : _Item_Title_Url
    }
    
    let _MPCart : any =   localStorage.getItem("MPCart");
  
    let MPCart : Array<CartModel> = [];
    // if(_MPCart !== undefined && _MPCart !== null  && _MPCart !== ""){
    //     MPCart =  MPCart.concat(JSON.parse(_MPCart));
    // }

    // let _Cart : any = JSON.parse(_MPCart);
    // _Cart?.forEach((item : any) => {
    //     if(item?.Item_Id){
    //         MPCart.push(item);
    //     }
    //   });


    let _Cart : any = JSON.parse(_MPCart);
    if (Array.isArray(_Cart)) {
        _Cart?.forEach((item : any) => {
            if(item?.Item_Id){
                MPCart.push(item);
            }
          });
      } else {
        if(_Cart?.Item_Id){
        MPCart.push(_Cart);
        }
      }
  
    if(actionType === 'Add'){
        
        if(MPCart === undefined || MPCart === null  || MPCart.length === 0){
            localStorage.setItem("MPCart",JSON.stringify(model));
        }
        else{

            let isItemExists  : any = MPCart.filter(x => x.Item_Id === _Item_Id && x.Seller_Id == _Seller_Id).length;
            if(isItemExists > 0){
              let _index =  MPCart.findIndex(x => x.Item_Id === _Item_Id && x.Seller_Id == _Seller_Id);
              MPCart[_index].Quantity = MPCart[_index].Quantity + 1;
              localStorage.setItem("MPCart",JSON.stringify(MPCart));
            }
            else{
           let AddMPCart =  JSON.stringify(MPCart.concat(model));
            localStorage.setItem("MPCart",AddMPCart);
            }

        }
    }
    else if(actionType === 'Update'){
        MPCart[index].Quantity = _Quantity;
        localStorage.setItem("MPCart",JSON.stringify(MPCart));
    }
    else if(actionType === 'Delete'){
        
            MPCart = MPCart?.filter((x : any )=> x.Item_Id !== _Item_Id);
            localStorage.setItem("MPCart",JSON.stringify(MPCart));
    }

    return actionType;
}

export function RemoveAllItemFromCart(){
    
    localStorage.setItem("MPCart",JSON.stringify(""));
}

export function GetCart(){
    
    let _MPCart : any =   localStorage.getItem("MPCart");
    let MPCart : Array<CartModel> = [];
    //_MPCart = _MPCart?.replace('""','');

    let _Cart : any = JSON.parse(_MPCart);
    if (Array.isArray(_Cart)) {
        _Cart?.forEach((item : any) => {
            if(item?.Item_Id){
                MPCart.push(item);
            }
          });
      } else {
        if(_Cart?.Item_Id){
        MPCart.push(_Cart);
        }
      }

    // if(_MPCart !== undefined && _MPCart !== null  && _MPCart !== ""){
    //     MPCart =  MPCart.concat(JSON.parse(_MPCart));
    // }
    return MPCart;

}